import { render, staticRenderFns } from "./PersonalReviewer.vue?vue&type=template&id=47a28698"
import script from "./PersonalReviewer.vue?vue&type=script&lang=js"
export * from "./PersonalReviewer.vue?vue&type=script&lang=js"
import style0 from "./PersonalReviewer.vue?vue&type=style&index=0&id=47a28698&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports